import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { BooleanInput } from "@angular/cdk/coercion";
import { Subject, takeUntil } from "rxjs";
import { UserDetails } from "app/core/models/auth/user-details.model";
import { UserDetailsService } from "app/core/services/user-details.service";
import { AuthRedirectDebugService } from "app/core/auth/auth-redirect-debug.service";
import { AUTH_REDIRECT_STATE_KEY, AuthRedirectReason } from "app/core/auth/auth-redirect-reason";

@Component({
    selector: "user",
    templateUrl: "./user.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: "user",
})
export class UserComponent implements OnInit, OnDestroy {
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: UserDetails;

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserDetailsService,
        private _authRedirectDebug: AuthRedirectDebugService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        this._userService.user$.pipe(takeUntil(this._unsubscribeAll)).subscribe((user: UserDetails) => {
            this.user = user;

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }
    }

    /**
     * Profile
     */
    goToProfile(): void {
        this._router.navigate(["/user/profile"]);
    }

    /**
     * Sign out
     */
    signOut(): void {
        this._authRedirectDebug.log(AuthRedirectReason.ManualLogout);
        this._router.navigate(["/logout"], {
            state: { [AUTH_REDIRECT_STATE_KEY]: AuthRedirectReason.ManualLogout },
        });
    }
}
